import { render, staticRenderFns } from "./SetParameter.vue?vue&type=template&id=2267a130&scoped=true"
import script from "./SetParameter.vue?vue&type=script&lang=js"
export * from "./SetParameter.vue?vue&type=script&lang=js"
import style0 from "./SetParameter.vue?vue&type=style&index=0&id=2267a130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2267a130",
  null
  
)

export default component.exports